import { faCaretDown, faCheck, faMagnifyingGlass, faXmark } from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { useEffect, useState } from 'react';
import { useNavigate, useSearchParams } from 'react-router-dom';
import { getAllLevels } from '~/api/levels';
import { getProblemForPagination } from '~/api/problems';
import ProblemsTable from '~/components/ProblemsTable';
import './problems.scss';
import clsx from 'clsx';
import styles from './problems.module.scss';

import problemsData from './data.json';
const statusData = [
    {
        id: 1,
        name: 'Todo',
    },
    {
        id: 2,
        name: 'Solved',
    },
    {
        id: 3,
        name: 'Attempted',
    },
];

function Problems() {
    const navigate = useNavigate();
    const [params, setParams] = useSearchParams();
    const page = typeof params.get('page') === 'string' ? params.get('page') : '1';
    const level = typeof params.get('level') === 'string' ? params.get('level') : undefined;
    const status = typeof params.get('status') === 'string' ? params.get('status') : undefined;
    const search = typeof params.get('search') === 'string' ? params.get('search') : undefined;

    const [statuses, setStatuses] = useState(statusData);
    const [text, setText] = useState(search);
    const [currentUser, setCurrentUser] = useState(undefined);

    const [textOfSearch, setTextOfSearch] = useState('');
    const [levels, setLevels] = useState([]);
    const [problems, setProblems] = useState(problemsData);

    const handleChangeSearchInput = (event) => {
        setTextOfSearch(event.target.value);
    };

    const handleSubmitSearch = () => {
        // console.log(text);
        if (!textOfSearch) {
            if (level && status) {
                navigate(`/problems/?page=${page}&level=${level}&status=${status}`);
            } else if (!level && status) {
                navigate(`/problems/?page=${page}&status=${status}`);
            } else if (level && !status) {
                navigate(`/problems/?page=${page}&level=${level}`);
            } else {
                navigate(`/problems/?page=${page}`);
            }
        } else {
            if (level && status) {
                navigate(`/problems/?page=${page}&level=${level}&status=${status}&search=${textOfSearch}`);
            } else if (!level && status) {
                navigate(`/problems/?page=${page}&status=${status}&search=${textOfSearch}`);
            } else if (level && !status) {
                navigate(`/problems/?page=${page}&level=${level}&search=${textOfSearch}`);
            } else {
                navigate(`/problems/?page=${page}&search=${textOfSearch}`);
            }
        }
    };

    const filterLevel = (lel) => {
        if (level === lel.name) {
            if (search && status) {
                navigate(`/problems/?page=1&status=${status}&search=${search}`);
            } else if (!search && status) {
                navigate(`/problems/?page=1&status=${status}`);
            } else if (search && !status) {
                navigate(`/problems/?page=1&search=${search}`);
            } else {
                navigate(`/problems/?page=1`);
            }
        } else {
            if (search && status) {
                navigate(`/problems/?page=1&level=${lel.name}&status=${status}&search=${search}`);
            } else if (!search && status) {
                navigate(`/problems/?page=1&level=${lel.name}&status=${status}`);
            } else if (search && !status) {
                navigate(`/problems/?page=1&level=${lel.name}&search=${search}`);
            } else {
                navigate(`/problems/?page=1&level=${lel.name}`);
            }
        }
    };

    const filterStatus = (sta) => {
        if (status === sta.name) {
            if (search && level) {
                navigate(`/problems/?page=1&level=${level}&search=${search}`);
            } else if (!search && level) {
                navigate(`/problems/?page=1&level=${level}`);
            } else if (search && !level) {
                navigate(`/problems/?page=1&search=${search}`);
            } else {
                navigate(`/problems/?page=1`);
            }
        } else {
            if (search && level) {
                navigate(`/problems/?page=1&level=${level}&status=${sta.name}&search=${search}`);
            } else if (!search && level) {
                navigate(`/problems/?page=1&level=${level}&status=${sta.name}`);
            } else if (search && !level) {
                navigate(`/problems/?page=1&status=${sta.name}&search=${search}`);
            } else {
                navigate(`/problems/?page=1&status=${sta.name}`);
            }
        }
        // setCurrentLevel(level);
    };

    const deleteStatus = () => {
        if (search && level) {
            navigate(`/problems/?page=1&level=${level}&search=${search}`);
        } else if (search && !level) {
            navigate(`/problems/?page=1&search=${search}`);
        } else if (!search && level) {
            navigate(`/problems/?page=1&level=${level}`);
        } else {
            navigate(`/problems/?page=1`);
        }
    };

    const deleteLevel = () => {
        if (search && status) {
            navigate(`/problems/?page=1&status=${status}&search=${search}`);
        } else if (search && !status) {
            navigate(`/problems/?page=1&search=${search}`);
        } else if (!search && status) {
            navigate(`/problems/?page=1&status=${status}`);
        } else {
            navigate(`/problems/?page=1`);
        }
    };

    const deleteText = () => {
        if (status && level) {
            navigate(`/problems/?page=1&status=${status}&level=${level}`);
        } else if (status && !level) {
            navigate(`/problems/?page=1&status=${status}`);
        } else if (!status && level) {
            navigate(`/problems/?page=1&level=${level}`);
        } else {
            navigate(`/problems/?page=1`);
        }
    };

    useEffect(() => {
        (async () => {
            var session = localStorage.getItem('session');
            var user_id;
            if (session) {
                session = JSON.parse(session);
                user_id = session.user.id;
                // setCurrentUser(session.user);
            } else {
                user_id = 'empty';
            }

            var curLevel = level ? level : 'empty';
            var curStatus = status ? status : 'empty';
            var curText = search ? search : 'empty';
            var response = await getProblemForPagination(user_id, curLevel, curStatus, curText);
            var newProblems = response.body;
            if (status && status !== 'Todo') {
                newProblems = response.body.filter((problem) => problem.status === status);
            } else if (status && status === 'Todo') {
                newProblems = response.body.filter(
                    (problem) => problem.status !== 'Attempted' && problem.status !== 'Solved',
                );
            }
            console.log(newProblems);
            setProblems(newProblems);
        })();
    }, [level, search, status]);

    useEffect(() => {
        (async () => {
            const getLevels = await getAllLevels();
            setLevels(getLevels);
        })();
    }, []);

    return (
        <div className={clsx(styles.problems)}>
            <div className="container">
                <div className={clsx(styles.innerProblems)}>
                    <div className={clsx(styles.title)}>List Of Problems</div>
                    <div className={clsx(styles.sortBar)}>
                        <div className={clsx(styles.sortBarSearch)}>
                            <div className={clsx(styles.sortBarSearchIcon)}>
                                <FontAwesomeIcon icon={faMagnifyingGlass} />
                            </div>
                            <div className={clsx(styles.sortBarSearchInput)}>
                                <input
                                    type="text"
                                    value={textOfSearch}
                                    placeholder="Search by problem title..."
                                    className={clsx('form-control', styles.sortBarFormControl)}
                                    onChange={handleChangeSearchInput}
                                    onKeyUp={handleSubmitSearch}
                                />
                            </div>
                        </div>
                        <div className={clsx(styles.sortBarOptions)}>
                            <div className={clsx('dropdown', styles.sortBarDropDown)}>
                                <button
                                    className={clsx('dropdown-toggle', styles.sortBarDropDownToggle)}
                                    type="button"
                                    data-bs-toggle="dropdown"
                                    aria-expanded="false"
                                >
                                    Difficulty
                                    <span className={clsx(styles.sortBarDropDownIcon)}>
                                        <FontAwesomeIcon icon={faCaretDown} />
                                    </span>
                                </button>
                                <ul className={clsx('dropdown-menu', styles.dropdownMenu)}>
                                    {levels.map((lel) => {
                                        if (lel.name === level) {
                                            return (
                                                <li
                                                    className={clsx(
                                                        'd-flex',
                                                        'align-items-center',
                                                        'justify-content-between',
                                                        'dropdown-item',
                                                        styles.dropdownItem,
                                                    )}
                                                    onClick={() => {
                                                        filterLevel(lel);
                                                    }}
                                                >
                                                    {lel.name}
                                                    <span>
                                                        <FontAwesomeIcon icon={faCheck} />
                                                    </span>
                                                </li>
                                            );
                                        } else
                                            return (
                                                <li
                                                    className={clsx('dropdown-item', styles.dropdownItem)}
                                                    onClick={() => {
                                                        filterLevel(lel);
                                                    }}
                                                >
                                                    {lel.name}
                                                </li>
                                            );
                                    })}
                                </ul>
                            </div>
                            <div className={clsx('dropdown', styles.sortBarDropDown)}>
                                <button
                                    className={clsx('dropdown-toggle', styles.sortBarDropDownToggle)}
                                    type="button"
                                    data-bs-toggle="dropdown"
                                    aria-expanded="false"
                                >
                                    Status
                                    <span className={clsx(styles.sortBarDropDownIcon)}>
                                        <FontAwesomeIcon icon={faCaretDown} />
                                    </span>
                                </button>
                                <ul className={clsx('dropdown-menu', styles.dropdownMenu)}>
                                    {statuses.map((sta) => {
                                        if (sta.name === status) {
                                            return (
                                                <li
                                                    className={clsx(
                                                        'd-flex',
                                                        'align-items-center',
                                                        'justify-content-between',
                                                        'dropdown-item',
                                                        styles.dropdownItem,
                                                    )}
                                                    onClick={() => {
                                                        filterStatus(sta);
                                                    }}
                                                >
                                                    {sta.name}
                                                    <span>
                                                        <FontAwesomeIcon icon={faCheck} />
                                                    </span>
                                                </li>
                                            );
                                        } else
                                            return (
                                                <li
                                                    className={clsx('dropdown-item', styles.dropdownItem)}
                                                    onClick={() => {
                                                        filterStatus(sta);
                                                    }}
                                                >
                                                    {sta.name}
                                                </li>
                                            );
                                    })}
                                </ul>
                            </div>
                            {/* 
                            <div className={clsx('dropdown', styles.sortBarDropDown)}>
                                <button
                                    className={clsx('dropdown-toggle', styles.sortBarDropDownToggle)}
                                    type="button"
                                    data-bs-toggle="dropdown"
                                    aria-expanded="false"
                                >
                                    Categories
                                    <span className={clsx(styles.sortBarDropDownIcon)}>
                                        <FontAwesomeIcon icon={faCaretDown} />
                                    </span>
                                </button>
                                <ul className={clsx('dropdown-menu', styles.dropdownMenu)}>
                                    {levels.map((lel) => {
                                        if (lel.name === level) {
                                            return (
                                                <li
                                                    className={clsx(
                                                        'd-flex',
                                                        'align-items-center',
                                                        'justify-content-between',
                                                        'dropdown-item',
                                                        styles.dropdownItem,
                                                    )}
                                                    onClick={() => {
                                                        filterLevel(lel);
                                                    }}
                                                >
                                                    {lel.name}
                                                    <span>
                                                        <FontAwesomeIcon icon={faCheck} />
                                                    </span>
                                                </li>
                                            );
                                        } else
                                            return (
                                                <li
                                                    className={clsx('dropdown-item', styles.dropdownItem)}
                                                    onClick={() => {
                                                        filterLevel(lel);
                                                    }}
                                                >
                                                    {lel.name}
                                                </li>
                                            );
                                    })}
                                </ul>
                            </div>
                            */}
                        </div>
                    </div>
                    {(level || status || search) && (
                        <div className="mt-4">
                            <div className="d-flex align-items-center">
                                {level && (
                                    <div className={clsx('d-flex', 'align-items-center', styles.filterItem)}>
                                        <div className="pe-2">{level}</div>
                                        <div className="filter-item-delete" onClick={deleteLevel}>
                                            <FontAwesomeIcon icon={faXmark} />
                                        </div>
                                    </div>
                                )}
                                {status && (
                                    <div className={clsx('d-flex', 'align-items-center', styles.filterItem)}>
                                        <div className="pe-2">{status}</div>
                                        <div className="filter-item-delete" onClick={deleteStatus}>
                                            <FontAwesomeIcon icon={faXmark} />
                                        </div>
                                    </div>
                                )}
                                {search && (
                                    <div className={clsx('d-flex', 'align-items-center', styles.filterItem)}>
                                        <div className="pe-2">{search}</div>
                                        <div className="filter-item-delete" onClick={deleteText}>
                                            <FontAwesomeIcon icon={faXmark} />
                                        </div>
                                    </div>
                                )}
                            </div>
                        </div>
                    )}
                    <div className={clsx(styles.problemsTable)}>
                        <div className={clsx(styles.problemsHead)}>
                            <div className={clsx(styles.problemsCol1, styles.textCenter)}>ID</div>
                            <div className={clsx(styles.problemsCol5)}>Problem Title</div>
                            <div className={clsx(styles.problemsCol3)}>Categories</div>
                            <div className={clsx(styles.problemsCol1D5)}>Level</div>
                            <div className={clsx(styles.problemsCol1D5)}>Status</div>
                        </div>
                        <div className={clsx(styles.problemsBody)}>
                            <ProblemsTable
                                problems={problems}
                                page={JSON.parse(page)}
                                level={level}
                                status={status}
                                search={search}
                            />
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
}

export default Problems;
